import { appConfig } from './AppConfig';

export const INSTAPAY_API = {
  PAY: appConfig.getServerUrl() + '/api/acceptance/payments/pay',
  INQUIRY: appConfig.getServerUrl() + '/api/acceptance/instapay/inquiry',
  CANCEL: appConfig.getServerUrl() + '/api/acceptance/instapay/cancel',
  FORCE_CLOSURE:
    appConfig.getServerUrl() + '/api/acceptance/instapay/force_closure',
};

export const HEADERS_CONFIG = {
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
};
